"use strict";

// 保存データ取得
function getRecentlyViewedProducts() {
  try {
    return JSON.parse(localStorage.getItem("recentlyViewedProducts")) || [];
  } catch (e) {
    return [];
  }
}

// 保存処理（商品ページのみ）
(function () {
  if (!window.location.pathname.includes('/products/')) return;

  let items = JSON.parse(localStorage.getItem("recentlyViewedProducts")) || [];

  const currentHandle = window.location.pathname
    .split('/products/')[1]
    ?.split('?')[0];

  if (!currentHandle) return;

  items = items.filter(item => item.handle !== currentHandle);

  items.push({
    handle: currentHandle,
    timestamp: Date.now()
  });

  localStorage.setItem("recentlyViewedProducts", JSON.stringify(items));
})();

if (!customElements.get("recently-viewed-products")) {
  class RecentlyViewedProducts extends HTMLElement {
    connectedCallback() {
      const list = this.querySelector("[data-recently-viewed-list]");
      if (!list) return;

      let items = getRecentlyViewedProducts();

      // sectionの設定を取得
      const maxItems = parseInt(this.dataset.productsToShow) || items.length;

      // 上限に沿って切り取る
      items = items.slice(-maxItems).toReversed();

      const handles = items.map(p => p.handle);

      Promise.all(
        handles.map(handle => {
          const url = `/products/${handle}?section_id=recently-viewed-item&handle=${handle}`;

          return fetch(url)
            .then(res => res.text())
            .then(html => {
              const div = document.createElement("div");
              div.innerHTML = html;
              return div.querySelector(".grid__item") || div.firstElementChild;
            })
            .catch(() => null);
        })
      ).then(elements => {
        const valid = elements.filter(el => el);
        if (!valid.length) {
          this.closest('.shopify-section').style.display = 'none';
          return;
        }
        valid.forEach(el => list.appendChild(el));
      });
    }
  }

  customElements.define("recently-viewed-products", RecentlyViewedProducts);
}